"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.get_first = exports.validateEmail = exports.process_drf_errors = exports.uniqueId = exports.toPrecision = exports.emptyChoice = exports.stringSort = exports.isInternetExplorer = exports.preventDefault = exports.arrayMoveClone = exports.Placer = exports.findIndexById = exports.degrees = exports.radians = exports.assignAllAttrs = void 0;
var react_sortable_hoc_1 = require("react-sortable-hoc");
var uuidv4 = require("uuid/v4");
function assignAllAttrs(a, b) {
    for (var field in a) {
        if (a.hasOwnProperty(field) && b.hasOwnProperty(field)) {
            b[field] = a[field];
        }
    }
}
exports.assignAllAttrs = assignAllAttrs;
function radians(degrees) {
    return (degrees * Math.PI) / 180;
}
exports.radians = radians;
function degrees(radians) {
    return (radians * 180) / Math.PI;
}
exports.degrees = degrees;
function findIndexById(objects, id) {
    return objects.findIndex(function (obj) { return obj.id == id; });
}
exports.findIndexById = findIndexById;
var Placer = (function () {
    function Placer(limits) {
        this.START_RADIUS = 30;
        this.RUNS = 50;
        this.ORIGIN_WEIGHT = 2;
        this.knownPositions = [];
        this.limits = limits;
    }
    Placer.prototype.getPlacement = function (coordinate) {
        var startPosition = this.getStartPosition(coordinate);
        var radius = this.START_RADIUS;
        var lastPosition = startPosition;
        var lastScore = 0;
        while (radius > 0) {
            var newPosition = this.getRandomPosition(startPosition, radius);
            var newScore = this.getScore(newPosition, startPosition);
            if (newScore > lastScore) {
                lastPosition = newPosition;
                lastScore = newScore;
            }
            radius -= this.START_RADIUS / this.RUNS;
        }
        if (lastPosition == coordinate) {
            console.log("Failed to find better spot");
        }
        this.knownPositions.push(lastPosition);
        return lastPosition;
    };
    Placer.prototype.getRandomPosition = function (position, radius) {
        var randomRotation = radians(Math.random() * 360);
        var xOffset = Math.cos(randomRotation) * radius;
        var yOffset = Math.sin(randomRotation) * radius;
        return {
            x: position.x + xOffset,
            y: position.y + yOffset,
        };
    };
    Placer.prototype.getScore = function (position, origin) {
        if (this.outOfBounds(position)) {
            return 0;
        }
        var closest = null;
        this.knownPositions.forEach(function (knownPosition) {
            var distance = Math.abs(Math.sqrt(Math.pow(knownPosition.x - position.x, 2) +
                Math.pow(knownPosition.y - position.y, 2)));
            if (closest === null || distance < closest) {
                closest = distance;
            }
        });
        var distancetoOrigin = Math.abs(Math.sqrt(Math.pow(origin.x - position.x, 2) +
            Math.pow(origin.y - position.y, 2)));
        return closest - distancetoOrigin / this.ORIGIN_WEIGHT;
    };
    Placer.prototype.outOfBounds = function (position) {
        return (position.x < this.limits.minX ||
            position.x > this.limits.maxX ||
            position.y < this.limits.minY ||
            position.y > this.limits.maxY);
    };
    Placer.prototype.getStartPosition = function (position) {
        var x = position.x;
        var y = position.y;
        if (x < this.limits.minX) {
            x += (this.limits.maxX - this.limits.minX) / 10;
        }
        else if (x > this.limits.maxX) {
            x -= (this.limits.maxX - this.limits.minX) / 10;
        }
        if (y < this.limits.minY) {
            y += (this.limits.maxY - this.limits.minY) / 10;
        }
        else if (y > this.limits.maxY) {
            y -= 10;
        }
        return {
            x: x,
            y: y,
        };
    };
    return Placer;
}());
exports.Placer = Placer;
function arrayMoveClone(list, oldIndex, newIndex) {
    var newList = [];
    list.forEach(function (item) { return newList.push(item); });
    return (0, react_sortable_hoc_1.arrayMove)(newList, oldIndex, newIndex);
}
exports.arrayMoveClone = arrayMoveClone;
function preventDefault(event) {
    if (event.preventDefault) {
        try {
            event.preventDefault();
        }
        catch (e) {
            event.returnValue = false;
        }
    }
    else {
        event.returnValue = false;
    }
}
exports.preventDefault = preventDefault;
function isInternetExplorer() {
    return window.navigator.userAgent.indexOf("Trident") >= 0;
}
exports.isInternetExplorer = isInternetExplorer;
function stringSort(a, b) {
    if (a < b)
        return -1;
    if (a > b)
        return 1;
    return 0;
}
exports.stringSort = stringSort;
exports.emptyChoice = {
    display_name: "-",
    value: null,
};
function toEngineeringFormat(x, n) {
    var y = Math.abs(x);
    var exponent = log10(y) || 0;
    var eng_exponent = exponent - (exponent % 3);
    var z = round(y / Math.pow(10, eng_exponent), n);
    var u = z.toString();
    var dec_pt_index = u.indexOf(".");
    var num_fig_after_dp = u.substring(dec_pt_index + 1).length;
    var num_fig_before_dp = u.substring(0, dec_pt_index).length;
    var num_sig_fig = num_fig_after_dp + num_fig_before_dp;
    var num_pad_fig = n - num_sig_fig;
    var padding = repeat("0", num_pad_fig);
    var sign = x < 0 ? "-" : "";
    return sign + u + padding + "e" + eng_exponent.toString();
}
function round(x, n) {
    return Math.round(x * Math.pow(10, n)) / Math.pow(10, n);
}
function log10(x) {
    return Math.log(x) / Math.log(10);
}
function repeat(s, n) {
    if (n <= 0)
        return "";
    if (n == 1)
        return s;
    else
        return s + repeat(s, n - 1);
}
function toPrecision(x, n) {
    if (n === void 0) { n = 4; }
    if (x == 0)
        return x.toString();
    if (Math.abs(x) < Math.pow(10, -4) || Math.abs(x) >= Math.pow(10, 6))
        return toEngineeringFormat(x, n);
    else
        return round(x, n).toString();
}
exports.toPrecision = toPrecision;
function uniqueId(prefix) {
    if (prefix === void 0) { prefix = "id"; }
    return "".concat(prefix).concat(uuidv4());
}
exports.uniqueId = uniqueId;
function process_drf_errors(data, prefix) {
    var messages = [];
    prefix = prefix ? prefix + " " : "";
    if (typeof data != "object") {
        messages.push((prefix !== "non_field_errors " ? prefix : "") + data);
        return messages;
    }
    Object.keys(data).forEach(function (key) {
        var value = data[key];
        if (Array.isArray(value)) {
            var errors = value.map(function (one_value) {
                return process_drf_errors(one_value, prefix + key);
            });
            errors.forEach(function (error_strings) {
                messages = messages.concat(error_strings);
            });
        }
        else {
            messages = messages.concat(process_drf_errors(value, prefix + key));
        }
    });
    return messages;
}
exports.process_drf_errors = process_drf_errors;
function validateEmail(email) {
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}
exports.validateEmail = validateEmail;
function get_first(elements) {
    if ((elements === null || elements === void 0 ? void 0 : elements.length) > 0)
        return elements[0];
    return undefined;
}
exports.get_first = get_first;
